import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { useStorePickerContext } from "@components/Store/StorePicker/storePicker.context";

import "./noResults.scss";

export const NoResults = () => {
    const { t } = useGranite();

    const { clear } = useStorePickerContext();

    return (
        <section className={"store-picker-no-results"}>
            <p>{t("form.storePicker.nothingFound")}</p>
            <Button type={"button"} color={"link"} onClick={clear}>
                {t("form.storePicker.nothingFound.reset")}
            </Button>
        </section>
    );
};
